import React from 'react';
import Icon from '@ant-design/icons';
import { TabKeyType } from '../../../types';
const DepSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M870.4 0c84.832 0 153.6 68.768 153.6 153.6v716.8c0 84.832-68.768 153.6-153.6 153.6H153.6c-84.832 0-153.6-68.768-153.6-153.6V153.6C0 68.768 68.768 0 153.6 0h716.8zM567.4688 262.4H456.5312C439.8912 262.4 428.8 273.4912 428.8 290.1312v110.9376c0 16.64 11.0912 27.7312 27.7312 27.7312h27.7376v55.4688H345.6c-16.64 0-27.7312 11.0912-27.7312 27.7312v83.2h-27.7376C273.4912 595.2 262.4 606.2912 262.4 622.9312v110.9376c0 16.64 11.0912 27.7312 27.7312 27.7312h110.9376c16.64 0 27.7312-11.0912 27.7312-27.7312V622.9312c0-16.64-11.0912-27.7312-27.7312-27.7312h-27.7376v-55.4688h277.3376V595.2h-27.7376C606.2912 595.2 595.2 606.2912 595.2 622.9312v110.9376c0 16.64 11.0912 27.7312 27.7312 27.7312h110.9376c16.64 0 27.7312-11.0912 27.7312-27.7312V622.9312c0-16.64-11.0912-27.7312-27.7312-27.7312h-27.7376V512c0-16.64-11.0912-27.7312-27.7312-27.7312H539.7312V428.8h27.7376c16.64 0 27.7312-11.0912 27.7312-27.7312V290.1312c0-16.64-11.0912-27.7312-27.7312-27.7312z"
      p-id="40333"
      fill="#1686ff"
    ></path>
  </svg>
);
const SearchSvg = () => (
  <svg
    width="16px"
    height="16.00px"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="31496"
  >
    <path
      d="M430.762667 42.666667c214.357333 0 388.096 176.213333 388.096 393.6a395.605333 395.605333 0 0 1-91.264 253.610666l196.949333 206.208a51.242667 51.242667 0 0 1 0 70.826667 46.762667 46.762667 0 0 1-67.669333 0l-200.704-210.176a382.634667 382.634667 0 0 1-225.408 73.173333C216.405333 829.866667 42.666667 653.653333 42.666667 436.266667 42.666667 218.88 216.405333 42.666667 430.762667 42.666667z m0 90.837333c-164.864 0-298.538667 135.552-298.538667 302.762667 0 167.253333 133.674667 302.805333 298.538667 302.805333 164.906667 0 298.538667-135.552 298.538666-302.805333 0-167.210667-133.632-302.762667-298.538666-302.762667z"
      p-id="31497"
      fill="#8F959E"
    ></path>
  </svg>
);
const WorkLineSVG = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="40539"
  >
    <path
      d="M870.4 0c84.832 0 153.6 68.768 153.6 153.6v716.8c0 84.832-68.768 153.6-153.6 153.6H153.6c-84.832 0-153.6-68.768-153.6-153.6V153.6C0 68.768 68.768 0 153.6 0h716.8zM633.0944 636.4992c-44.704 0-80.9408 36.2368-80.9408 80.9408s36.2368 80.9408 80.9408 80.9408 80.9408-36.2368 80.9408-80.9408-36.2368-80.9408-80.9408-80.9408z m125.9136 47.9616a32.9792 32.9792 0 1 0 0 65.9584 32.9792 32.9792 0 0 0 0-65.9584z m-125.9136 3.2384a29.7408 29.7408 0 1 1 0 59.4816 29.7408 29.7408 0 0 1 0-59.4816zM513.1776 288.7424H441.2288a26.9824 26.9824 0 0 0-26.9824 26.9824v170.88H369.28a26.9824 26.9824 0 0 0 0 53.9584h44.9664V717.44a26.9824 26.9824 0 0 0 26.9824 26.9824h71.9488a26.9824 26.9824 0 1 0 0-53.9648h-44.9664V540.5504l44.9664 0.0064a26.9824 26.9824 0 1 0 0-53.9584h-44.9664V342.6944h44.9664a26.9824 26.9824 0 1 0 0-53.9584zM252.3648 444.6336c-43.0528 0-77.952 34.8928-77.952 77.9456 0 43.0464 34.8992 77.9456 77.952 77.9456 43.0464 0 77.9456-34.8992 77.9456-77.952 0-43.0464-34.8992-77.9392-77.952-77.9392z m380.736-5.9968c-44.7104 0-80.9472 36.2368-80.9472 80.9408s36.2368 80.9472 80.9408 80.9472 80.9408-36.2432 80.9408-80.9472c0-44.704-36.2368-80.9408-80.9408-80.9408z m0 51.2a29.7408 29.7408 0 1 1 0 59.488 29.7408 29.7408 0 0 1 0-59.488z m125.9072-9.2288a32.9792 32.9792 0 1 0 0 65.952 32.9792 32.9792 0 0 0 0-65.952zM633.088 228.7808c-44.704 0-80.9408 36.2432-80.9408 80.9472 0 44.704 36.2368 80.9408 80.9408 80.9408s80.9408-36.2368 80.9408-80.9408-36.2368-80.9472-80.9408-80.9472z m125.9136 47.968a32.9792 32.9792 0 1 0 0 65.952 32.9792 32.9792 0 0 0 0-65.952z m-125.9136 3.232a29.7408 29.7408 0 1 1 0 59.488 29.7408 29.7408 0 0 1 0-59.488z"
      p-id="40747"
      fill="#1686ff"
    ></path>
  </svg>
);
export function DepIcon() {
  return <Icon component={DepSvg} />;
}

export function WorkLineIcon() {
  return <Icon component={WorkLineSVG} />;
}

export function SearchIcon() {
  return <Icon component={SearchSvg} />;
}
export const getIcon = (type: any) => {
  if (type === TabKeyType.Department) {
    return <DepIcon></DepIcon>;
  }
  if (type === TabKeyType.WorkLine) {
    return <WorkLineIcon></WorkLineIcon>;
  }
  return null;
};
